import { IconButton } from "@tvg/fuse/button";
import React from "react";
import { MenuIcon as MenuIconComponent } from "../icons";
import styles from "./MenuIconButton.module.css";

export interface MenuIconButtonProps {
  dataTestId?: string;
  onMenuButtonClick: (
    event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
  ) => void;
}

const MenuIconButton: React.FC<MenuIconButtonProps> = ({
  dataTestId,
  onMenuButtonClick,
}) => (
  <>
    <IconButton
      text="Menu"
      className={`${styles.menuIconButton} navi-header-fe__menu-button slide-out-menu__icon-button`}
      onKeyDown={(e: React.KeyboardEvent<HTMLElement>) => {
        if (e.key === "Enter" || e.key === " ") onMenuButtonClick(e);
      }}
      dataTestId={dataTestId}
      href="#sidepanel-navigation"
      icon={<MenuIconComponent />}
      onClick={onMenuButtonClick}
      role="button"
      size="small"
    />
  </>
);

export default MenuIconButton;
